import React from 'react';
import ClicksEmailIcon from 'assets/svgs/ClicksEmailIcon';
// import DeliveredEmailIcon from 'assets/svgs/DeliveredEmailIcon';
// import OpenEmailIcon from 'assets/svgs/OpenEmailIcon';
import SideMenuIcon from 'assets/svgs/SideMenuIcon';
import TotalRecipientIcon from 'assets/svgs/TotalRecipientIcon';
import TotalSentEmailIcon from 'assets/svgs/TotalSentEmailIcon';
import { primaryFont, wMedium } from 'constants/utilsStyles';
import styled from 'styled-components';
import ListCardPopover from '../Popovers/ListCardPopover';
import { IListItem } from 'modules/Audience/interface';
import { Tooltip } from 'antd';

const Footer = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  .side-menu-div {
    cursor: pointer;
    .side-menu-icon {
      width: 20px; 
      height: 24px;
    }
  }
`;
const FooterIconDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  svg {
    width: 17px;
    height: 12px;
  }
  .icon-views {
    font-family: ${primaryFont};
    font-weight: ${wMedium};
    font-size: 10px;
    line-height: 12px;
    color: #C2C2C2;
    margin-top: 5px;
  }
`;

type FooterIconPropType = {
  icon: object,
  views: string | number,
  tooltipText: string,
};

export const ListFooterIconDiv = function ListFooterIconDiv(props: FooterIconPropType) {
  const { icon, views, tooltipText } = props;
  return (
    <Tooltip title={tooltipText} >
      <FooterIconDiv>
        {icon}
        <span className='icon-views'>{views}</span>
      </FooterIconDiv>
    </Tooltip>
  );
};

interface ListCardFooterGlobalProps {
  list: IListItem,
  actionHandler: (listId: number) => void;
  isSearched: boolean;
}

const ListCardFooterGlobal = function ListCardFooterGlobal(props: ListCardFooterGlobalProps) {
  const { list, actionHandler, isSearched } = props;
  const { totalClicks, totalContacts, totalSent, listId } = list;
  // console.log(props);
  return (
    <Footer className='list-card-footer-global'>
      <ListFooterIconDiv icon={<TotalRecipientIcon />} views={totalContacts} tooltipText='Total Contacts' />
      <ListFooterIconDiv icon={<TotalSentEmailIcon />} views={totalSent} tooltipText='Emails Sent' />
      {/* <ListFooterIconDiv icon={<DeliveredEmailIcon />} views='456' /> */}
      {/* <ListFooterIconDiv icon={<OpenEmailIcon />} views='456' /> */}
      <ListFooterIconDiv icon={<ClicksEmailIcon />} views={totalClicks} tooltipText='Total Clicks' />
      <div className='side-menu-div'>
        <ListCardPopover listTotalContacts={totalContacts} listId={listId} isSearched={isSearched} actionHandler={actionHandler}>
          <SideMenuIcon />
        </ListCardPopover>
      </div>
    </Footer>
  );
};
export default ListCardFooterGlobal;